export default function RiskThreatAssessmentController(
  $q,
  $scope,
  bcpDataService,
  loaderService,
  userService
) {
  const vm = this;

  vm.isExpanded = false;
  vm.hasData = false;

  vm.handleExpandRiskThreatAssessment = _handleExpandRiskThreatAssessment;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    _initEventListeners();
    _initPermissions();
    _initStatus();
  }

  function _initPermissions() {
    vm.canExpand = vm.status !== 'Risk Threat Assessment Not Started';
    return userService.getUserPermissionSet('bcp').then((permissions) => {
      vm.permissions = permissions;
    });
  }

  function _initEventListeners() {
    $scope.$on(
      'refreshBCPRiskThreatAssessments',
      _refreshAssessmentThreats
    );
  }

  function _initStatus() {
    let enterpriseThreatAssessmentStatus = '';
    if (vm.status.enterpriseThreatAssessmentStatus === 'Enterprise Threat Assessment Complete') {
      enterpriseThreatAssessmentStatus = 'complete';
    } else if (
      vm.status.enterpriseThreatAssessmentStatus !== 'Enterprise Threat Assessment Complete'
      && vm.status.enterpriseThreatAssessmentStatus !== 'Enterprise Threat Assessment Not Started'
    ) {
      enterpriseThreatAssessmentStatus = 'in progress';
    } else {
      enterpriseThreatAssessmentStatus = 'not started';
    }

    let topThreatsByProcessStatus = '';
    if (vm.status.topThreatsByProcessStatus === 'Top Threats by Process Assessment Complete') {
      topThreatsByProcessStatus = 'complete';
    } else if (
      vm.status.topThreatsByProcessStatus !== 'Top Threats by Process Assessment Complete'
      && vm.status.topThreatsByProcessStatus !== 'No Process Threats Assessed'
    ) {
      topThreatsByProcessStatus = 'in progress';
    } else {
      topThreatsByProcessStatus = 'not started';
    }

    if (enterpriseThreatAssessmentStatus === 'complete' && topThreatsByProcessStatus === 'complete') {
      vm.riskThreatAssessmentStatus = 'complete';
    } else if (enterpriseThreatAssessmentStatus === 'not started' && topThreatsByProcessStatus === 'not started') {
      vm.riskThreatAssessmentStatus = 'not started';
    } else {
      vm.riskThreatAssessmentStatus = 'in progress';
    }
    vm.riskThreatAssessmentStatusText = `${vm.status.enterpriseThreatAssessmentStatus}<br>
      ${vm.status.topThreatsByProcessStatus}`;
  }

  function _refreshAssessmentThreats() {
    const dfdRefresh = $q.defer();

    const dfdThreatOptions = _refreshThreatOptions();

    dfdThreatOptions.then(() => {
      _refreshThreats().then(dfdRefresh.resolve);
    });

    return dfdRefresh.promise;
  }

  function _refreshThreats() {
    const dfdThreats = $q.defer();

    bcpDataService.getThreats(
      vm.assessmentId
    ).then((response) => {
      vm.assessmentThreats = response.data.result;
      dfdThreats.resolve();
    });

    return dfdThreats.promise;
  }

  function _refreshThreatOptions() {
    const dfdOptions = $q.defer();
    if (!vm.threatOptions) {
      loaderService.showViewLoader = true;
      bcpDataService.getThreatOptions().then((response) => {
        vm.threatOptions = response.data;
        loaderService.showViewLoader = false;
        dfdOptions.resolve();
      });
    } else {
      dfdOptions.resolve();
    }

    return dfdOptions.promise;
  }

  function _handleExpandRiskThreatAssessment() {
    if (vm.canExpand) {
      if (vm.hasData) {
        vm.isExpanded = !vm.isExpanded;
      } else {
        _refreshAssessmentThreats().then(() => {
          vm.hasData = true;
          vm.isExpanded = true;
        });
      }
    }
  }
}

RiskThreatAssessmentController.$inject = [
  '$q',
  '$scope',
  'bcpDataService',
  'loaderService',
  'userService'
];
